export default __webpack_public_path__ + "locales/sq-AL/Ldap.json?hash=c6f4544cd5a563e649a54ffbeab08c3f";